//webkitURL is deprecated but nevertheless
URL = window.URL || window.webkitURL;

let gumStream; 						//stream from getUserMedia()
let recorder; 						//WebAudioRecorder object
let timeLimit = 600;       //Recorder time limit
let input; 							//MediaStreamAudioSourceNode  we'll be recording
let encodingType; 					//holds selected encoding for resulting audio (file)
let encodeAfterRecord = true;       // when to encode
let startTime = null;
let intervalId = null;

// shim for AudioContext when it's not avb.
let AudioContext = window.AudioContext || window.webkitAudioContext;
let audioContext; //new audio context to help us record

export function fetchExhibitVoiceNotes(exhibitId) {
    $('.exhibit-voice-container').find('.exhibit-voice-group .voice_notes').load('/voice_notes/exhibit/'+exhibitId, function () {
        $(document).trigger('audioLoaded', [exhibitId]);

        $('.exhibit-voice-group').find('audio').each(function () {
            let audioElement = $(this)[0];

            audioElement.addEventListener('play', function() {
                $('.exhibit-voice-visibility').addClass('voice-note-playing');
            });

            audioElement.addEventListener('pause', function() {
                $('.exhibit-voice-visibility').removeClass('voice-note-playing');
            });

            audioElement.addEventListener('ended', function() {
                $('.exhibit-voice-visibility').removeClass('voice-note-playing');
            });
        });

    });
}
export function fetchImageVoiceNotes(imageId) {
    $('.image-voice-container').find('.image-voice-group[data-voice-image-id="'+imageId+'"] .voice_notes').load('/voice_notes/image/'+imageId, function () {
        $(document).trigger('audioLoaded', [imageId]);

        $('.image-voice-group').find('audio').each(function () {
            let audioElement = $(this)[0];

            audioElement.addEventListener('play', function() {
                $('.image-voice-visibility').addClass('voice-note-playing');
            });

            audioElement.addEventListener('pause', function() {
                $('.image-voice-visibility').removeClass('voice-note-playing');
            });

            audioElement.addEventListener('ended', function() {
                $('.image-voice-visibility').removeClass('voice-note-playing');
            });
        });

    });
}

export function fetchDotVoiceNotes(dotId) {
    $('.dot-voice-container').find('.dot-voice-group .voice_notes').load('/voice_notes/dot/'+dotId, function () {
        $(document).trigger('audioLoaded', [dotId]);

        $('.dot-voice-group').find('audio').each(function () {
            let audioElement = $(this)[0];

            audioElement.addEventListener('play', function() {
                $('.dot-voice-visibility').addClass('voice-note-playing');
            });

            audioElement.addEventListener('pause', function() {
                $('.dot-voice-visibility').removeClass('voice-note-playing');
            });

            audioElement.addEventListener('ended', function() {
                $('.dot-voice-visibility').removeClass('voice-note-playing');
            });
        });
    });
    $('#modal-dotfull').find('.dot-voice-visibility').attr('data-dot-id', dotId);
    $('#modal-dotfull').find('.dot-voice-container .dot-voice-group').attr('data-voice-dot-id', dotId);
}

export function editImageVoiceNotes(imageId) {
    $('#imageForm').load('/voice_notes/image/'+imageId+'/edit');
}
$(document).on('click',".upload-voice",function(){
    const from = $(this).attr('data-from')
    let voice_id = $(this).attr('data-id')
    let model = $(this).parent('div').parent('div').attr('model')
    let model_id = $(this).parent('div').parent('div').attr('model-id')
    let exhibit_id = $(this).parent('div').attr('exhibit-id')
    let voice_title = $(this).parent('div').find('input[name="voice_title"]').val()
    let auto_transcribe = $(this).parent('div').find('input[name="voice_title"]').val()

    uploadVoiceNote(voice_id, model, model_id, exhibit_id, voice_title, from, null, auto_transcribe);

})

function uploadVoiceNote(voice_id, model, model_id, exhibit_id, voice_title, from, voice_file = null, auto_transcribe = true) {
    try {
        let voice = voice_file != null ? voice_file : $('#audio-recording-' + voice_id).attr('src');

        let formData = new FormData()
        formData.append('from', from)
        formData.append('voice', voice)
        formData.append('model', model)
        formData.append('model_id', model_id)
        formData.append('exhibit_id', exhibit_id)
        formData.append('title', voice_title)
        formData.append('auto_transcribe', auto_transcribe.toString())

        $('<i class="fas fa-spinner fa-spin voice-upload-loading" style="color: #41526c;font-size: 30px;vertical-align: super;"></i>').insertBefore($('.delete-voice[data-id="'+voice_id+'"]'))
        payload('/voice_note', formData, 'POST').then(function (result) {
            console.log('[' + new Date().toISOString() + '] Voice note upload successful:', result)
            if (from == 'dashboard' && window.location.pathname == '/admin/images/create') {
                $('.voice-upload-loading').remove()
                $('.voice_notes').append('<input type="text" hidden="hidden" name="voice_note_ids[]" value="'+result.voice_note.id+'"/>')
                $('#audio-recording-' + voice_id).nextAll('i').eq(1).attr('data-id', result.voice_note.id)
            } else {
                reFetchVoiceNotes(model, model_id)
            }
        }).catch(function (result) {
            const timestamp = new Date().toISOString();
            const errorDetails = {
                voice_id: voice_id,
                model: model,
                model_id: model_id,
                exhibit_id: exhibit_id,
                error: result,
                status: result.status,
                responseText: result.responseText
            };
            console.error('[' + timestamp + '] Voice note upload failed:', errorDetails);

            $('.voice-upload-loading').remove()
            $('.upload-voice[data-id="'+voice_id+'"]').removeClass('d-none')

            let errorMsg = 'Voice Note Upload Failed\n\n';
            errorMsg += 'Time: ' + timestamp + '\n';
            errorMsg += 'Voice ID: ' + voice_id + '\n';
            errorMsg += 'Model: ' + model + ' (ID: ' + model_id + ')\n';
            errorMsg += 'Status: ' + (result.status || 'unknown') + '\n';
            errorMsg += 'Error: ' + (result.responseJSON?.message || result.statusText || result.responseText || 'Unknown error');
            alert(errorMsg);
        })
    } catch (error) {
        const timestamp = new Date().toISOString();
        console.error('[' + timestamp + '] Voice note upload exception:', {
            voice_id: voice_id,
            model: model,
            model_id: model_id,
            error: error.message,
            stack: error.stack
        })
        $('.voice-upload-loading').remove()
        $('.upload-voice[data-id="'+voice_id+'"]').removeClass('d-none')

        let errorMsg = 'Voice Note Upload Exception\n\n';
        errorMsg += 'Time: ' + timestamp + '\n';
        errorMsg += 'Voice ID: ' + voice_id + '\n';
        errorMsg += 'Model: ' + model + ' (ID: ' + model_id + ')\n';
        errorMsg += 'Error: ' + error.message;
        alert(errorMsg);
    }
}

function uploadReplacedVoiceNote(voice_id, model, model_id, voice_title, voice_file = null, auto_transcribe = true) {
    try {
        let voice = voice_file != null ? voice_file : $('#audio-record-' + voice_id).attr('src');

        let formData = new FormData()
        formData.append('title', voice_title)
        formData.append('new_voice', voice)
        formData.append('auto_transcribe', auto_transcribe.toString())
        formData.append('_method', 'PUT');

        $('<i class="fas fa-spinner fa-spin voice-upload-loading" style="color: #41526c;font-size: 30px;vertical-align: super;"></i>').insertBefore($('.delete-voice[data-id="'+voice_id+'"]'))
        payload("/voice_note/"+voice_id, formData, 'POST').then(function (result) {
            console.log('[' + new Date().toISOString() + '] Voice note replacement successful:', result)
            reFetchVoiceNotes(model, model_id)
            $('.btn-select-audio').removeClass("button--active");
        }).catch(function (result) {
            const timestamp = new Date().toISOString();
            const errorDetails = {
                voice_id: voice_id,
                model: model,
                model_id: model_id,
                error: result,
                status: result.status,
                responseText: result.responseText
            };
            console.error('[' + timestamp + '] Voice note replacement failed:', errorDetails);

            $('.voice-upload-loading').remove()
            $('.upload-voice[data-id="'+voice_id+'"]').removeClass('d-none')
            $('.btn-select-audio').removeClass("button--active");

            let errorMsg = 'Voice Note Replacement Failed\n\n';
            errorMsg += 'Time: ' + timestamp + '\n';
            errorMsg += 'Voice ID: ' + voice_id + '\n';
            errorMsg += 'Model: ' + model + ' (ID: ' + model_id + ')\n';
            errorMsg += 'Status: ' + (result.status || 'unknown') + '\n';
            errorMsg += 'Error: ' + (result.responseJSON?.message || result.statusText || result.responseText || 'Unknown error');
            alert(errorMsg);
        })
    } catch (error) {
        const timestamp = new Date().toISOString();
        console.error('[' + timestamp + '] Voice note replacement exception:', {
            voice_id: voice_id,
            model: model,
            model_id: model_id,
            error: error.message,
            stack: error.stack
        })
        $('.voice-upload-loading').remove()
        $('.upload-voice[data-id="'+voice_id+'"]').removeClass('d-none')
        $('.btn-select-audio').removeClass("button--active");

        let errorMsg = 'Voice Note Replacement Exception\n\n';
        errorMsg += 'Time: ' + timestamp + '\n';
        errorMsg += 'Voice ID: ' + voice_id + '\n';
        errorMsg += 'Model: ' + model + ' (ID: ' + model_id + ')\n';
        errorMsg += 'Error: ' + error.message;
        alert(errorMsg);
    }
}

// Keep a dot's speaker badge in sync after its voice notes change.
// The badge on the pin (.dot-pointer) is rendered from the cached dot.total_voices in
// renderDotPointers(), so hiding it in the DOM alone is not enough - the next re-render
// (showPins, dots panel toggle, page change) would bring the stale badge back. Dot ids
// are unique across images, so the cache is scanned rather than keyed by image id, which
// the delete call site does not know.
export function syncDotVoiceBadge(dotId, voiceCount) {
    const count = parseInt(voiceCount, 10) || 0;

    $('.dot-pointer[data-id="' + dotId + '"] .badge').toggleClass('d-none', count === 0);

    const cache = window.imageDataCache || {};
    Object.keys(cache).forEach(function (imageId) {
        const dots = cache[imageId] && cache[imageId].dots;
        if (!Array.isArray(dots)) return;
        dots.forEach(function (dot) {
            if (dot.id == dotId) {
                dot.total_voices = count;
            }
        });
    });
}

function reFetchVoiceNotes(model, model_id) {
    if (model == 'exhibit') {
        $('.exhibit-voice-edit').load('/voice_notes/exhibit/'+model_id+'/edit');
    }else if(model == 'image') {
        if ($('.image-voice-group .voice_notes').attr('from') == 'dashboard' || $('#recordings-cont').attr('from') == 'dashboard') {
            $('.image-voice-group .voice_notes').load('/voice_notes/image/' + model_id + '/edit', function() {
                $('#recordings-cont').attr('from', 'dashboard');
                $('.voice-record-timer').removeClass('d-none');
                $('.voice-list').addClass('pl-2');
            });
        } else {
            $('.image-voice-edit').load('/voice_notes/image/' + model_id + '/edit');
        }
    }else if(model == 'dot') {
        $('.dot-voice-edit').load('/voice_notes/dot/'+model_id+'/edit');
    }
}

$(document).on('input',".voice-title",function(){
    $(this).next('.update-voice-title').removeClass('d-none')
})

$(document).on('click',".update-voice-title",function(){
    let title = $(this).prev('.voice-title').val()
    let model = $(this).prev('.voice-title').attr('model')
    let model_id = $(this).prev('.voice-title').attr('model-id')
    let voice_id = $(this).prev('.voice-title').attr('data-id')

    updateVoiceNoteTitle(model, model_id, voice_id, title, $(this))
})

function updateVoiceNoteTitle(model, model_id, voice_id, title, element) {

    let formData = new FormData()
    formData.append('title', title)
    formData.append('_method', 'PUT');

    element.addClass('d-none')
    $('<i class="fas fa-spinner fa-spin voice-update-loading" style="color: #41526c;font-size: 30px;vertical-align: super;"></i>').insertAfter(element)

    payload("/voice_note/"+voice_id, formData, "POST").then(function (result) {
        console.log(result)
        $('.voice-update-loading').remove()
        reFetchVoiceNotes(model, model_id)
    }).catch(function (result) {
        console.log(result)
        $('.voice-update-loading').remove()
        element.removeClass('d-none')
    })

}

$(document).on('click',".toggle-voice-visibility",function(){
    let title = $(this).parent('div').parent('div').parent('div').find('input[name="voice_title"]').val()
    let model = $(this).attr('model')
    let model_id = $(this).attr('model-id')
    let voice_id = $(this).attr('data-id')
    let is_private = $(this).attr('data-visibility') == 'private' ? 0 : 1

    updateVoiceNoteVisibility(model, model_id, voice_id, title, is_private, $(this))
})

function updateVoiceNoteVisibility(model, model_id, voice_id, title, is_private, element) {

    let formData = new FormData()
    formData.append('title', title)
    formData.append('is_private', is_private)
    formData.append('_method', 'PUT');

    element.addClass('d-none')
    $('<i class="fas fa-spinner fa-spin voice-update-loading" style="color: #41526c;font-size: 30px;vertical-align: super;"></i>').insertAfter(element)

    payload("/voice_note/"+voice_id, formData, "POST").then(function (result) {
        console.log(result)
        reFetchVoiceNotes(model, model_id)
    }).catch(function (result) {
        console.log(result)
        $('.voice-update-loading').remove()
        element.removeClass('d-none')
    })
}

function updateVoiceNoteSorting(model, model_id, voice_list, element) {

    let formData = new FormData()
    formData.append('voice_list', JSON.stringify(voice_list))
    formData.append('_method', 'PUT');

    element.addClass('d-none')
    $('<i class="fas fa-spinner fa-spin voice-update-loading" style="color: #41526c;font-size: 30px;vertical-align: super;"></i>').insertAfter(element)

    payload("/voice_notes/sort", formData, "POST").then(function (result) {
        console.log(result)
        reFetchVoiceNotes(model, model_id)
    }).catch(function (result) {
        console.log(result)
        $('.voice-update-loading').remove()
        element.removeClass('d-none')
    })
}

$(document).on('click',".delete-voice",function(){

    if (!confirm($(this).data('confirm'))){
        return false;
    }

    console.log('delete button pressed')

    if ($(this).data('status') == 'draft') {
        if ($(this).parent().parent().attr('from') == 'dashboard') {
            $('input[name="voice_note_ids[]"][value="'+$(this).data('id')+'"]').remove();
        }
        $(this).parent('div').remove()
        return true
    }

    let model = $(this).parent('div').parent('div').attr('model')
    let model_id = $(this).parent('div').parent('div').attr('model-id')
    let voice_id = $(this).attr('data-id')

    deleteVoiceNote(model, model_id, voice_id, $(this))
})

function deleteVoiceNote(model, model_id, voice_id, element) {
    try {
        let formData = new FormData()
        formData.append('model', model)
        formData.append('model_id', model_id)

        element.addClass('d-none')
        $('<i class="fas fa-spinner fa-spin voice-remove-loading" style="color: #41526c;font-size: 30px;vertical-align: super;"></i>').insertBefore('.dropdown[model="'+model+'"][model-id="'+model_id+'"][voice-id="'+voice_id+'"]')

        payload("/voice_notes/"+model+"/"+voice_id, formData, "DELETE").then(function (result) {
            console.log('[' + new Date().toISOString() + '] Voice note deletion successful:', result)
            $('.voice-remove-loading').remove()
            $('.voice-note-item[data-voice-id="'+voice_id+'"]').remove()

            // clear the pin's speaker badge as soon as the last voice note is gone,
            // rather than waiting on the broadcast (which needs pusher configured)
            if (model == 'dot' && typeof result.voice_count !== 'undefined') {
                syncDotVoiceBadge(model_id, result.voice_count)
            }
        }).catch(function (result) {
            const timestamp = new Date().toISOString();
            const errorDetails = {
                voice_id: voice_id,
                model: model,
                model_id: model_id,
                error: result,
                status: result.status,
                responseText: result.responseText
            };
            console.error('[' + timestamp + '] Voice note deletion failed:', errorDetails);

            $('.voice-remove-loading').remove()
            element.removeClass('d-none')

            let errorMsg = 'Voice Note Deletion Failed\n\n';
            errorMsg += 'Time: ' + timestamp + '\n';
            errorMsg += 'Voice ID: ' + voice_id + '\n';
            errorMsg += 'Model: ' + model + ' (ID: ' + model_id + ')\n';
            errorMsg += 'Status: ' + (result.status || 'unknown') + '\n';
            errorMsg += 'Error: ' + (result.responseJSON?.message || result.statusText || result.responseText || 'Unknown error');
            alert(errorMsg);
        })
    } catch (error) {
        const timestamp = new Date().toISOString();
        console.error('[' + timestamp + '] Voice note deletion exception:', {
            voice_id: voice_id,
            model: model,
            model_id: model_id,
            error: error.message,
            stack: error.stack
        })
        $('.voice-remove-loading').remove()
        element.removeClass('d-none')

        let errorMsg = 'Voice Note Deletion Exception\n\n';
        errorMsg += 'Time: ' + timestamp + '\n';
        errorMsg += 'Voice ID: ' + voice_id + '\n';
        errorMsg += 'Model: ' + model + ' (ID: ' + model_id + ')\n';
        errorMsg += 'Error: ' + error.message;
        alert(errorMsg);
    }
}

function payload(url, data, method) {
    let response = false

    return new Promise(function(resolve, reject) {
        $.ajax({
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: url,
            // dataType: "json",
            method: method,
            processData: false,
            contentType: false,
            data: data,
        }).done(function (data) {
            response = data
            resolve(response)
        }).fail(function (xhr) {
            response = xhr
            reject(response)
        });
    })
}

$(document).on('click',".dummy-record-button", function () {
    let modelType = $(this).attr('model')
    let modelId = $(this).attr('model-id')
    let exhibitId = $(this).attr('exhibit-id')
    let recordButton = $('.button--active');

    showEditModal(modelType);
    $(this).parent('div').addClass('d-none');

    audioRecord(recordButton, modelType, modelId, exhibitId)
});

$(document).on('click',".btn-record-audio", function () {
    let modelType = $(this).attr('model')
    let modelId = $(this).attr('model-id')
    let exhibitId = $(this).attr('exhibit-id')

    hideEditModal(modelType);

    $('.dummy-record-button').attr({'model': modelType, 'model-id': modelId, 'exhibit-id': exhibitId})
    $('.dummy-record-button').parent('div').removeClass('d-none')

    audioRecord($(this), modelType, modelId, exhibitId)
})

function audioRecord(recordButton, modelType, modelId, exhibitId) {
    if (!recordButton.hasClass("button--active")) {
        startRecording(recordButton, modelType, modelId, exhibitId)
    } else {
        stopRecording(recordButton, modelType, modelId, exhibitId)
    }
}
function startRecording(recordButton, modelType, modelId, exhibitId) {

    /*
        Simple constraints object, for more advanced features see
        https://addpipe.com/blog/audio-constraints-getusermedia/
    */

    const constraints = {audio: true, video: false};

    /*
    	We're using the standard promise based getUserMedia()
    	https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
	*/

    navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {

        /*
            create an audio context after getUserMedia is called
            sampleRate might change after getUserMedia is called, like it does on macOS when recording through AirPods
            the sampleRate defaults to the one set in your OS for your playback device

        */
        audioContext = new AudioContext();

        //assign to gumStream for later use
        gumStream = stream;

        /* use the stream */
        input = audioContext.createMediaStreamSource(stream);

        //stop the input from playing back through the speakers
        //input.connect(audioContext.destination)

        //get the encoding
        encodingType = 'wav';

        //disable the encoding selector
        recordButton.addClass("button--active");
        startTimer(modelType, modelId);

        recorder = new WebAudioRecorder(input, {
            workerDir: "/js/voice_recorder/audio_recorder/", // must end with slash
            encoding: encodingType,
            numChannels:2, //2 is the default, mp3 encoding supports only 2
            onEncoderLoading: function(recorder, encoding) {
                // show "loading encoder..." display
                console.log("Loading "+encoding+" encoder...")
            },
            onEncoderLoaded: function(recorder, encoding) {
                // hide "loading encoder..." display
                console.log(encoding+" encoder loaded")
            }
        });

        recorder.onComplete = function(recorder, blob) {
            console.log('[' + new Date().toISOString() + '] Encoding complete')
            try {
                createDownloadLink(blob,recorder.encoding,modelType,modelId,exhibitId);
            } catch (error) {
                const timestamp = new Date().toISOString();
                console.error('[' + timestamp + '] Error creating download link:', {
                    modelType: modelType,
                    modelId: modelId,
                    exhibitId: exhibitId,
                    error: error.message,
                    stack: error.stack
                })

                let errorMsg = 'Voice Recording Processing Failed\n\n';
                errorMsg += 'Time: ' + timestamp + '\n';
                errorMsg += 'Model: ' + modelType + ' (ID: ' + modelId + ')\n';
                errorMsg += 'Error: ' + error.message;
                alert(errorMsg);
            }
        }

        recorder.setOptions({
            timeLimit:timeLimit,
            encodeAfterRecord:encodeAfterRecord,
            ogg: {quality: 0.5},
            mp3: {bitRate: 160}
        });

        //start the recording process
        recorder.startRecording();

        console.log('[' + new Date().toISOString() + '] Recording started')

    }).catch(function(err) {
        //enable the record button if getUSerMedia() fails
        const timestamp = new Date().toISOString();
        console.error('[' + timestamp + '] getUserMedia error:', {
            modelType: modelType,
            modelId: modelId,
            exhibitId: exhibitId,
            error: err.name,
            message: err.message
        })
        recordButton.removeClass("button--active");

        let errorMsg = 'Microphone Access Failed\n\n';
        errorMsg += 'Time: ' + timestamp + '\n';
        errorMsg += 'Model: ' + modelType + ' (ID: ' + modelId + ')\n';
        errorMsg += 'Error: ' + err.name + '\n';
        errorMsg += 'Message: ' + err.message + '\n\n';
        errorMsg += 'Please check your browser permissions and try again.';
        alert(errorMsg);

    });

    //disable the record button
    recordButton.addClass("button--active");
}

function stopRecording(recordButton) {
    stopTimer();
    //stop microphone access
    gumStream.getAudioTracks()[0].stop();

    //disable the stop button
    recordButton.removeClass("button--active");

    //tell the recorder to finish the recording (stop recording + encode the recorded audio)
    recorder.finishRecording();

    console.log("Recording stopped")
}

function createDownloadLink(blob,encoding,modelType,modelId,exhibitId) {
    try {
        let recordingList = $('.recordings-cont-'+modelType+'-'+modelId)
        blobToBase64(blob).then(res => {
            try {
                let base_64_audio = res

                const newIdx = recordingList.children().length + 1
                const created_at = new Date().toISOString().slice(0, 16).replace('T', ' ');

                const newEl = document.createElement('div')
                newEl.setAttribute('exhibit-id', exhibitId)
                newEl.innerHTML = '<div class="d-flex flex-column">' +
                    '<audio class="pt-2" style="width: 80%" id="audio-recording-' + newIdx + '" controls preload="metadata"></audio> ' +
                    '<div class="d-flex flex-row mt-3">' +
                    '<i class="fas fa-cloud-upload-alt pointer upload-voice d-none" data-id="' + newIdx + '" style="color: #737373;font-size: 30px;vertical-align: super;"></i>' +
                    '<i class="far fa-trash-alt pointer delete-voice delete-voice-icon" data-status="draft" data-id="' + newIdx + '" data-confirm="Are you sure you want to delete selected voice note? \n!!!You can not undo or revert it back!!!" style="color: #db2100;font-size: 30px;vertical-align: super;"></i>' +
                    '</div>' +
                    '<input class="form-control" style="width: 100%" type="text" value="Voice Note [' + created_at + ']" name="voice_title"/>' +
                    '</div>'
                recordingList.prepend(newEl)

                const recordingEl = document.getElementById("audio-recording-" + newIdx);
                recordingEl.src = base_64_audio

                recordingEl.addEventListener('loadedmetadata', function() {
                    console.log('[' + new Date().toISOString() + '] Audio metadata loaded for recording ' + newIdx);
                }, { once: true });

                recordingEl.load();

                const autoTranscribe = $('#auto-transcribe').prop('checked')

                uploadVoiceNote(newIdx, modelType, modelId, exhibitId, 'Voice Note [' + created_at + ']', recordingList.attr('from'), null, autoTranscribe);
            } catch (error) {
                const timestamp = new Date().toISOString();
                console.error('[' + timestamp + '] Error processing voice note blob:', {
                    modelType: modelType,
                    modelId: modelId,
                    exhibitId: exhibitId,
                    error: error.message,
                    stack: error.stack
                })

                let errorMsg = 'Voice Recording Processing Error\n\n';
                errorMsg += 'Time: ' + timestamp + '\n';
                errorMsg += 'Model: ' + modelType + ' (ID: ' + modelId + ')\n';
                errorMsg += 'Stage: Processing blob\n';
                errorMsg += 'Error: ' + error.message;
                alert(errorMsg);
            }
        }).catch(function(error) {
            const timestamp = new Date().toISOString();
            console.error('[' + timestamp + '] Error converting blob to base64:', {
                modelType: modelType,
                modelId: modelId,
                exhibitId: exhibitId,
                error: error.message,
                stack: error.stack
            })

            let errorMsg = 'Voice Recording Conversion Error\n\n';
            errorMsg += 'Time: ' + timestamp + '\n';
            errorMsg += 'Model: ' + modelType + ' (ID: ' + modelId + ')\n';
            errorMsg += 'Stage: Converting to base64\n';
            errorMsg += 'Error: ' + (error.message || 'Unknown error');
            alert(errorMsg);
        })
    } catch (error) {
        const timestamp = new Date().toISOString();
        console.error('[' + timestamp + '] Error in createDownloadLink:', {
            modelType: modelType,
            modelId: modelId,
            exhibitId: exhibitId,
            error: error.message,
            stack: error.stack
        })

        let errorMsg = 'Voice Recording Preparation Error\n\n';
        errorMsg += 'Time: ' + timestamp + '\n';
        errorMsg += 'Model: ' + modelType + ' (ID: ' + modelId + ')\n';
        errorMsg += 'Stage: Preparing download link\n';
        errorMsg += 'Error: ' + error.message;
        alert(errorMsg);
    }
}

function createDownloadLinkForFile(blob,encoding,modelType,modelId,exhibitId) {

    let recordingList = $('.recordings-cont-'+modelType+'-'+modelId)
    const newIdx = recordingList.children().length + 1
    const created_at = new Date().toISOString().slice(0, 16).replace('T', ' ');
    const autoTranscribe = $('#auto-transcribe').prop('checked')

    uploadVoiceNote(newIdx, modelType, modelId, exhibitId, 'Voice Note [' + created_at + ']', recordingList.attr('from'), blob, autoTranscribe);
}

function createReplaceDownloadLink(blob,encoding,modelType,modelId,exhibitId,voiceId) {
    let recordingList = $('.recordings-cont-'+modelType+'-'+modelId)
    let audio = blob
    let recordingElTitle = recordingList.find('div[data-voice-id="'+voiceId+'"] .voice-title').val();
    const autoTranscribe = $('#auto-transcribe').prop('checked')

    uploadReplacedVoiceNote(voiceId, modelType, modelId, recordingElTitle, audio, autoTranscribe);
}



//helper function
function blobToBase64 (blob) {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
        reader.onloadend = () => {
            resolve(reader.result);
        };
    });
}

function updateTimer() {
    const now = new Date().getTime();
    const elapsedTime = now - startTime;
    // const hours = Math.floor(elapsedTime / 3600000);
    const minutes = Math.floor((elapsedTime % 3600000) / 60000);
    const seconds = Math.floor((elapsedTime % 60000) / 1000);

    if ((elapsedTime/1000) >= timeLimit) {
        let recordButton = $('.button--active')
        stopRecording(recordButton);
    }

    const formattedTime =
        // padNumber(hours) + ":" +
        padNumber(minutes) + ":" +
        padNumber(seconds);

    $(".voice-record-timer").text(formattedTime);
}

function padNumber(number) {
    return number.toString().padStart(2, '0');
}

function startTimer() {
    startTime = new Date().getTime();
    intervalId = setInterval(updateTimer, 1000);
}

function stopTimer() {
    clearInterval(intervalId);
    $(".voice-record-timer").text('00:00');
}

$(document).on('click',".btn-select-audio", function () {
    let modelType = $(this).attr('model')
    let modelId = $(this).attr('model-id')
    let exhibitId = $(this).attr('exhibit-id')
    $('.audioFileInput[model="'+modelType+'"][model-id="'+modelId+'"][exhibit-id="'+exhibitId+'"]').trigger('click');
})

$(document).on('click',".btn-replace-audio", function () {
    let modelType = $(this).attr('model')
    let modelId = $(this).attr('model-id')
    let exhibitId = $(this).attr('exhibit-id')
    let voiceId = $(this).attr('voice-id')

    const confirm_replace= confirm("After replacing the audio file, the old one will be deleted. \nAre you sure you want to continue replacing the audio?");
    if (confirm_replace) {
        $('.replaceAudioFileInput[model="'+modelType+'"][model-id="'+modelId+'"][exhibit-id="'+exhibitId+'"][voice-id="'+voiceId+'"]').trigger('click');
    }
})

// Listen for changes in the file input element
$(document).on('change',".audioFileInput", async function () {
    let modelType = $(this).attr('model')
    let modelId = $(this).attr('model-id')
    let exhibitId = $(this).attr('exhibit-id')
    // Get the selected file
    const selectedFile = this.files[0];
    let audio;

    if (selectedFile.type == "audio/wav" || selectedFile.type == "audio/x-wav") {
        audio = selectedFile;
    } else {
        alert('Just "wav" format is allowed, but you tried to upload the "'+selectedFile.type+'" file type.')
        return
    }
    $('.btn-select-audio').addClass("button--active");
    createDownloadLinkForFile(audio, 'wav', modelType, modelId, exhibitId);
});

$(document).on('change',".replaceAudioFileInput", async function () {
    let modelType = $(this).attr('model')
    let modelId = $(this).attr('model-id')
    let exhibitId = $(this).attr('exhibit-id')
    let voiceId = $(this).attr('voice-id')
    // Get the selected file
    const selectedFile = this.files[0];
    let audio;

    if (selectedFile.type == 'audio/wav' || selectedFile.type == 'audio/x-wav') {
        audio = selectedFile
    } else {
        alert('Just "wav" format is allowed, but you tried to upload the "'+selectedFile.type+'" file type.')
        return
    }
    createReplaceDownloadLink(audio, 'wav', modelType, modelId, exhibitId, voiceId);
});

$(document).on('click',".sort-voice-note", function () {
    $('.voice-note-item').addClass('sortable-item sortable-voice-note');
    $('.sort-voice-note').addClass('d-none');
    $('.cancel-sort-voice-note').removeClass('d-none');
    $('.save-sort-voice-note').removeClass('d-none');
    $('.sort-voice-note-arrows-alt').removeClass('d-none');
});

$(document).on('click',".save-sort-voice-note", function () {
    let modelType = $(this).parent().attr('model');
    let modelId = $(this).parent().attr('model-id');
    let order = [];
    $('.sortable[model="'+modelType+'"][model-id="'+modelId+'"]').find('.sortable-item').each(function (index) {
        order.push({
            id: $(this).data('voice-id'),
            order: index + 1
        });
    });
    updateVoiceNoteSorting(modelType, modelId, order, $(this))
});

$(document).on('click',".cancel-sort-voice-note", function () {
    let modelType = $(this).parent().attr('model');
    let modelId = $(this).parent().attr('model-id');
    reFetchVoiceNotes(modelType, modelId);
});

function audioToBlob(file) {
    if (file) {
        if (file.type == 'audio/wav' || file.type == 'audio/x-wav') {
            return new Blob([file], {type: 'audio/wav'})
        }

        return new Blob([file], {type: file.type})
    }
}

function hideEditModal(modelType) {
    if (modelType == 'exhibit') {
        $('.edit-crtexh').css('z-index', '0');
        $('#modal-crtexh-button').addClass('disabled');
        $('#modal-crtexh-button').prop('disabled', true);
    } else if(modelType == 'image') {
        $('#imageEdit').css('z-index', '0');
        $('.editImage').addClass('disabled');
    } else if(modelType == 'dot') {
        $('.edit-dotedit').css('z-index', '0');
        $('.editDot').addClass('disabled');
    }
    $('.modal-backdrop').css('z-index', '0');
}

function showEditModal(modelType) {
    if (modelType == 'exhibit') {
        $('.edit-crtexh').css('z-index', '1050');
        $('#modal-crtexh-button').removeClass('disabled');
        $('#modal-crtexh-button').prop('disabled', false);
    } else if(modelType == 'image') {
        $('#imageEdit').css('z-index', '1050');
        $('.editImage').removeClass('disabled');
    } else if(modelType == 'dot') {
        $('.edit-dotedit').css('z-index', '1050');
        $('.editDot').removeClass('disabled');
    }
    $('.modal-backdrop').removeAttr('style');
}

$(document).on('click',".btn-transcribe-audio", function () {
    let modelType = $(this).attr('model')
    let voiceId = $(this).attr('voice-id')

    transcriptionLoading()

    let formData = new FormData()
    formData.append('voice_note', voiceId)

    payload("/voice_note/transcription/"+voiceId, formData, "POST").then(function (result) {
        if (result.status == 'COMPLETED') {
            const voice_note_title = $('.voice-title[data-id='+voiceId+']').val();
            const transcription = '<p>Transcription | ' + voice_note_title +
                '<br>----------------------' +
                '<br>' + result.transcript +
                '</p>';
            if (modelType == 'exhibit') {
                window.editor_exh.setData(window.editor_exh.getData() + transcription);
            } else if (modelType == 'image') {
                window.editor_img_desc.setData(window.editor_img_desc.getData() + transcription);
            } else if (modelType == 'dot') {
                window.editor_dot.setData(window.editor_dot.getData() + transcription);
            }

            $('#transcriptLoading').remove();
        }
    }).catch(function (result) {
        console.log(result)
        $('#transcriptLoading').remove();
    })
})

function transcriptionLoading() {
    const overlay = `
    <div id="transcriptLoading">
      <div class="content">
        <img src="/images/local/transcript-loading.png" width="150" alt="Loading Transcript" />
        <p class="transcription-text">Generating the transcription...</p>
      </div>
    </div>
  `;
    $('body').append(overlay);
}

export function addTranscriptToDescription(voiceId, modelType, transcript, voiceTitle = null) {
    // try to get title from DOM first, fallback to passed title
    let voice_note_title = $('.voice-title[data-id='+voiceId+']').val();
    if (!voice_note_title && voiceTitle) {
        voice_note_title = voiceTitle;
    }
    if (!voice_note_title) {
        voice_note_title = 'Voice Note #' + voiceId;
    }

    const transcription = '<p>Transcription | ' + voice_note_title +
        '<br>----------------------' +
        '<br>' + transcript +
        '</p>';
    if (modelType == 'exhibit') {
        window.editor_exh.setData(window.editor_exh.getData() + transcription);
    } else if (modelType == 'image') {
        console.log('image desc')
        window.editor_img_desc.setData(window.editor_img_desc.getData() + transcription);
    } else if (modelType == 'dot') {
        window.editor_dot.setData(window.editor_dot.getData() + transcription);
    }
    $('#transcriptLoading').remove();
}

// Stop current audio if another one starts playing
document.addEventListener("play", function (e) {
    // Get the audio element that triggered the play event
    let currentAudio = e.target;

    // Pause and reset all other audio elements
    document.querySelectorAll("audio").forEach(function (audio) {
        if (audio !== currentAudio) {
            audio.pause();
            if (audio.currentTime !== 0) {
                audio.currentTime = 0;
            }
        }
    });
}, true);

window.reFetchVoiceNotes = (model, model_id) => {
    reFetchVoiceNotes(model, model_id);
}

window.addTranscriptToDescription = (voiceId, modelType, transcript, voiceTitle = null) => {
    addTranscriptToDescription(voiceId, modelType, transcript, voiceTitle);
}
